<div class="right-back col-12 d-flex" style="justify-content: center; align-items: center;">
    <div class="col-12 d-flex" style="justify-content: center; flex-wrap: wrap;">
        <div class="col-12 col-md-8 col-lg-6 col-xl-5 mt-4 d-flex" style="justify-content: end;">
            <div class="dropdown">
                <span class="language dropdown-toggle" id="dropdownLanguageSelect" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false" style="text-transform: uppercase;">
                    {{ languageMode }}
                    <span>
                        <img class="dropdown-rotate" width="20px" height="20px" src="../../../assets/arrow-up-down.svg">
                    </span>
                </span>
                <div class="dropdown-menu dropdown-menu-right py-2" aria-labelledby="dropdownLanguageSelect">
                    <div class="col-12 dropdown-item" (click)="setLanguage('en')"
                        style="color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
                        English
                    </div>
                    <div class="col-12 dropdown-item" (click)="setLanguage('nl')"
                        style="color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
                        Dutch
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 mt-2 d-flex" style="justify-content: center;">
            <img class="logo" src="../../../assets/Namelogo-dark.png" alt="Dialect">
        </div>

        <div class="col-12 d-flex" style="justify-content: center;">
            <div class="col-12 col-md-8 col-lg-6 col-xl-5 d-flex" style="justify-content: center; flex-wrap: wrap;">
                <div class="col-12 back p-4 p-md-5 mt-4 d-flex" style="justify-content: center; flex-wrap: wrap;">
                    <div class="col-12 pt-2 head">
                        {{ "PaymentSuccess.Payment Successful!" | translate }}
                    </div>

                    <div class="col-12 pt-2 desc text-center" style="opacity: 0.8;">
                        {{ "PaymentSuccess.Thank you for your purchase. Your subscription is now active and you're all set to get started." | translate }}
                    </div>

                    <div class="col-12 mt-4 back summary d-flex" *ngIf="subscriptionType || price"
                        style="justify-content: space-between; align-items: center; flex-wrap: wrap;">
                        <div class="col-12 col-sm-6 desc" *ngIf="subscriptionType">
                            <span style="opacity: 0.6;">{{ "PaymentSuccess.Plan" | translate }}</span>
                            <div style="font-weight: 600;">{{subscriptionType}}</div>
                        </div>
                        <div class="col-12 col-sm-6 desc text-sm-end" *ngIf="price">
                            <span style="opacity: 0.6;">{{ "PaymentSuccess.Amount" | translate }}</span>
                            <div style="font-weight: 600;">{{price}}</div>
                        </div>
                    </div>

                    <div class="col-12 mt-4 d-flex" style="justify-content: center;">
                        <button type="button" class="btn p-2" style="width: 100%;" (click)="onContinue()">
                            {{ "PaymentSuccess.Continue" | translate }}
                        </button>
                    </div>
                </div>

                <div class="col-12 mt-4 mb-5 d-flex desc" style="justify-content: center; opacity: 0.7;">
                    <span>{{ "PaymentSuccess.Need help?" | translate }}</span>
                    <a class="ms-1 help-link" routerLink="/help-center">{{ "PaymentSuccess.Contact support" | translate }}</a>
                </div>
            </div>
        </div>
    </div>
</div>
